export class JsLoader {
  static loadAll(urls: string[]): Promise<void>[] {
    const promises = urls.map(m => m.endsWith(".css") ? JsLoader.loadCss(m) : JsLoader.loadScript(m));
    return promises;
  }

  static loadCss(url: string): Promise<void> {
    const link = document.createElement("link");
    link.href = url;
    link.type = "text/css";
    link.rel = "stylesheet";
    link.media = "screen,print";

    document.getElementsByTagName("head")[0].appendChild(link);

    return Promise.resolve();
  }

  static loadScript(url: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (window[url]) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.onload = () => resolve();
      script.onerror = err => reject(err);
      script.src = url;
      window[url] = script;
      document.body.appendChild(script);
    });
  }
}
